import { Button, Divider, Form, Space, Typography } from "antd";

import type { LoginCredentials } from "@/types";

import { AccountFormItem } from "./AccountFormItem";
import { GoogleLoginButton } from "./GoogleLoginButton";
import { PasswordFormItem } from "./PasswordFormItem";

const { Text } = Typography;

interface PasswordLoginFormProps {
  googleDisabled?: boolean;
  isGoogleSubmitting?: boolean;
  isSubmitting?: boolean;
  onGoogleLogin: () => void;
  onSubmit: (payload: LoginCredentials) => void;
  onUseOtp: () => void;
}

export const PasswordLoginForm = ({
  googleDisabled = false,
  isGoogleSubmitting = false,
  isSubmitting = false,
  onGoogleLogin,
  onSubmit,
  onUseOtp,
}: PasswordLoginFormProps) => (
  <Form<LoginCredentials>
    layout="vertical"
    onFinish={(values) => {
      onSubmit(values);
    }}
  >
    <AccountFormItem autoFocus />
    <PasswordFormItem validateStrength={false} />

    <Space direction="vertical" size={12} style={{ width: "100%" }}>
      <Button block htmlType="submit" loading={isSubmitting} type="primary">
        Đăng nhập
      </Button>

      <Divider plain>
        <Text type="secondary">Hoặc</Text>
      </Divider>

      <GoogleLoginButton
        disabled={googleDisabled}
        loading={isGoogleSubmitting}
        onClick={onGoogleLogin}
      />

      <Button block onClick={onUseOtp}>
        Quay lại đăng nhập bằng OTP
      </Button>
    </Space>
  </Form>
);
